import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../../services/auth.service';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const isLoggedIn = AuthService.isAuthenticated();
  const isAdmin = AuthService.isAdmin();
  
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }
  
  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
};

export default PrivateRoute;